import React from 'react';


import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getUsersRestoreProgress,
    restoreUsers,
    stopUsersRestore,
} from 'src/openapi/admin/apis/BulkUsersRestoreApi';
import {useAppDispatch} from 'src/store/hooks';

import {FlatButton} from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {RemoveAttendeesModal} from './remove-attendees.modal';
import {
    selectRemoveAttendeesTask,
    selectRemoveAttendeesUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from './remove-attendees.slice';

import type {UsersRestore} from 'src/openapi/admin/models/UsersRestore';


type Props = {
    userIds: number[],
    conferenceAccountId: number,
    onDone: () => void,
};

export const RemoveAttendeesTool = ({userIds, conferenceAccountId, onDone}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClose, onClick} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}>
                <b>{TOOL_TITLE}</b>
            </FlatButton>
            <BulkActionTool<UsersRestore>
                shown={shown}
                onClose={onClose}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectRemoveAttendeesTask}
                uuidSelector={selectRemoveAttendeesUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(usersRestore, options) => (
                    apiDispatch(restoreUsers({...options, usersRestore}))
                )}
                getProgress={id => apiDispatch(getUsersRestoreProgress({id}))}
                stopAction={id => apiDispatch(stopUsersRestore({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({onCloseModal, processAction}) => (
                    <RemoveAttendeesModal {...{userIds, conferenceAccountId, onCloseModal, processAction}}/>
                )}
            </BulkActionTool>
        </>
    );
};
